<template>
  <TwTableFilterBar
    :filterModel="filterForm"
    :filterChips="filterChips"
    @apply="applyFilter"
  >
    <template #form="{ model: searchForm }">
      <!--
      <div class="row" style="border-bottom: 1px solid #BFBFCD;margin-bottom: 12px;">




        <el-form-item class='max-content' :label="$t('Label.Update Datetime')" prop='flowUpdateDatetime'>
          <el-date-picker
            popper-class="within-system-trading-list-days"
            v-model='searchForm.flowUpdateDatetime'
            type='datetimerange'
            range-separator='to'
            format='yyyy-MM-dd HH:mm'
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder='Start datetime'
            end-placeholder='End datetime'
            :pickerOptions="{
              onPick: pickUpdateDate,
              disabledDate: disabledUpdateDate,
              shortcuts
            }"
            :clearable="false"
            @blur="setUpdateDateInfo('reset')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('Label.Trading Flow Status')" prop="tradingProgressStatus">
          <el-select v-model="searchForm.tradingProgressStatus" placeholder="Select" clearable>
            <el-option
              v-for="status in tradingProgressStatuses"
              :key="status.code"
              :label="status.label"
              :value="status.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Label.Trading Name')" prop="tradingName">
          <el-input type="text" v-model="searchForm.tradingName" placeholder="Enter keyword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Label.Flow Name')" prop="flowName">
          <el-input type="text" v-model="searchForm.flowName" placeholder="Enter keyword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Label.Invoice No')" prop="invoiceNo">
          <el-input type="text" v-model="searchForm.invoiceNo" placeholder="Enter keyword"></el-input>
        </el-form-item>

        <div class="row detailed-conditions">
          <el-form-item class='max-content' :label="$t('Label.Create Datetime')" prop='createDatetime'>
            <el-date-picker
              v-model='searchForm.flowCreateDatetime'
              type='datetimerange'
              range-separator='to'
              format='yyyy-MM-dd HH:mm'
              value-format='yyyy-MM-dd HH:mm:ss'
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder='Start datetime'
              end-placeholder='End datetime'>
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Section(From)')" prop="fromSectionIds">
            <TwSelectSection v-model="searchForm.fromSectionIds" :sections="fromSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Section(To)')" prop="toSectionIds">
            <TwSelectSection v-model="searchForm.toSectionIds" :sections="toSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Trading/Flow ID')" prop="tradingFlowId">
            <el-input type="text" v-model.trim="searchForm.tradingFlowId" placeholder="Enter keyword" class="trading-flow"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Contract Date')" prop="contractDate">
            <el-date-picker
              v-model="searchForm.contractDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Seller')" prop="sellerName">
            <el-input type="text" v-model="searchForm.sellerName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Buyer')" prop="buyerName">
            <el-input type="text" v-model="searchForm.buyerName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Main Goods')" prop="goodsName">
            <el-input type="text" v-model="searchForm.goodsName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Owner')" prop="ownerSectionIds">
            <el-select v-model="searchForm.ownerSectionIds" class="section" :class="{multiple_selected: multipleSelect(searchForm.ownerSectionIds)}" popper-class="owner-section" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="section in ownerSectionLists"
                :key="section.sectionId"
                :label="section.sectionShortName"
                :value="section.sectionId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="row detailed-conditions">
          <el-form-item :label="$t('Label.Vessel Name')" prop="vesselName">
            <el-input type="text" v-model="searchForm.vesselName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.B/L No')" prop="blNo">
            <el-input type="text" v-model="searchForm.blNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Booking No')" prop="bookingNo">
            <el-input type="text" v-model="searchForm.bookingNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.ETD/BL Date')" prop="etdBlDate">
            <el-date-picker
              v-model="searchForm.etdBlDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Discharging Current ETA')" prop="currentEta">
            <el-date-picker
              v-model="searchForm.currentEta"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Port of Loading')" prop="portOfLOading">
            <el-input type="text" v-model="searchForm.portOfLoading" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Port of Discharging')" prop="portOfDischarging">
            <el-input type="text" v-model="searchForm.portOfDischarging" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Im Request Declaration Date')" prop="imRequestDeclarationDate">
            <el-date-picker
              v-model="searchForm.imRequestDeclarationDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Delivery Date')" prop="deliveryDate">
            <el-date-picker
              v-model="searchForm.deliveryDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Place of Devanning')" prop="devanningPlace">
            <el-input type="text" v-model="searchForm.devanningPlace" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Warehouse')" prop="warehouse">
            <el-input type="text" v-model="searchForm.warehouse" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Free Time')" prop="freeTime">
            <el-date-picker
              v-model="searchForm.freeTime"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Ex Request Declaration Date')" prop="exRequestDeclarationDate">
            <el-date-picker
              v-model="searchForm.exRequestDeclarationDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Vanning Date')" prop="vanningDate">
            <el-date-picker
              v-model="searchForm.vanningDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Place of Vanning')" prop="vanningPlace">
            <el-input type="text" v-model="searchForm.vanningPlace" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.CY CUT')" prop="cyCutDate">
            <el-date-picker
              v-model="searchForm.cyCutDate"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
        </div>
      </div>-->
    </template>
  </TwTableFilterBar>
</template>
<script>
import _ from 'lodash';
import { defineComponent, ref, computed } from '@vue/composition-api';
import dayjs from 'dayjs';

import { tradingFlowListFilterSchema } from '@/dictionaries/vue3/tradingList/tradingFlowListFilterSchema';

import TwTableFilterBar from '@/components/vue3/TwTableFilterBar.vue';

export default defineComponent({
  name: 'TradingFlowFilter',
  components: {
    TwTableFilterBar,
  },
  props: {
    filterForm: {
      type: Object,
      required: true,
    },
    filterChips: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const store = useStore;
    const fromSections = [];
    const toSections = [];
    const ownerSectionLists = computed(() => []);
    const shortcuts = [
      {
        text: 'Today',
        onClick(picker) {
          picker.$emit('pick', [
            dayjs().format('YYYY-MM-DD 00:00:00'),
            dayjs().format('YYYY-MM-DD 23:59:59'),
          ]);
        },
      },
    ];
    const defaultDate = dayjs()
      .subtract(1, 'month')
      .toDate();

    // multipleSelect
    const multipleSelect = computed(() => {
      return model => {
        return _.isArray(model) && model.length > 1;
      };
    });
    const pickUpdateDate = dates => {
      if (dates.maxDate) {
        // minFlowUpdateDatetimeの更新はsetUpdateInfo内で実施（shortcutでもリセットさせる必要があるため）
        // this.setUpdateDateInfo('reset');
      } else {
        // this.minFlowUpdateDatetime = dates.minDate;
        // this.setUpdateDateInfo();
      }
    };

    const disabledUpdateDate = date => {
      // if (this.minFlowUpdateDatetime) {
      //   return this.checkSystemMasterDaysOver(this.minFlowUpdateDatetime, date);
      // }
      return false;
    };

    // 適用ボタン
    const applyFilter = () => {
      console.log("apply")
      // emit('apply', { ...filterForm.value });
    };
    return {
      shortcuts,
      defaultDate,
      fromSections,
      toSections,
      ownerSectionLists,
      multipleSelect,
      pickUpdateDate,
      disabledUpdateDate,
      applyFilter,
    };
  },
});
</script>
<style lang="scss">
.search_unit {
  & .row {
    align-items: center;
  }
  & .el-form-item {
    margin-bottom: 24px;
  }
  & .max-content {
    width: max-content !important;
  }
}
</style>
